import { COOKIES } from '@bulknutrients/bulk-shared-lib/constants';
import Cookies from 'js-cookie';

export const useCsrfCookie = () => {
  const cookie = Cookies.get(COOKIES.csrf);
  return cookie;
};
